import {observable} from "mobx";
import NiceModal, {antdDrawer, useModal} from "@ebay/nice-modal-react";
import {observer} from "mobx-react";
import React from "react";
import {Drawer, notification, Button, Space} from "antd";
import {callWithCatch, pp} from "../utils";
import DataTable from "./DataTable";

const DuprModal = NiceModal.create(observer(({  }) => {
  let modal = useModal();

  const showConfirmation = DuprConnect.confirmationData;

  return <div>
    <Drawer
      title="Connect DUPR"
      bodyStyle={{padding: showConfirmation ? 16 : 0}}
      footer={null}
      // width={350}
      {...antdDrawer(modal)}
    >
      {showConfirmation ? (
        <div>
          <p className="text-lg">Is this <b>{gon.user.name}</b> DUPR?</p>
          <DataTable data={[
            ["DUPR ID:", showConfirmation.duprId],
            ["Doubles Rating:", showConfirmation.stats.doubles],
            ["Singles Rating:", showConfirmation.stats.singles]
          ]} />
          <Space style={{ marginTop: 16 }}>
            <Button onClick={() => DuprConnect.cancelConnection()}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => DuprConnect.confirmConnection(showConfirmation)}>
              Confirm & Connect
            </Button>
          </Space>
        </div>
      ) : (
        // <iframe width="100%" height="100%" src="https://dashboard.dupr.com/login-external-app/dGVzdC1jay0zYTE4ZDExNy1jM2FmLTQ2ZWQtZmI1OC0yMTNlMTU5MTNkNzk=" />
        <iframe width="100%" height="100%" src="https://dashboard.dupr.com/login-external-app/Y2stZjk1ZmU4MGUtMjUyZC00NWJmLWZkMDMtMGU0ZmEyZWMyNzQ0" />
      )}
    </Drawer>
  </div>
}));

export const DuprConnect = observable({
  dupr_xid: gon.user?.dupr_xid,
  rating: gon.player?.wpr,
  // fRating: gon.player?.finalRating,
  callback: null,
  confirmationData: null,
  handleMessage: e => {
    let data = e.data;
    if (!data.duprId)
      return;

    // Store the confirmation data and show it in the drawer
    DuprConnect.confirmationData = data;
  },
  isConnected: () => _.isNumber(DuprConnect.rating),
  cancelConnection: () => {
    DuprConnect.confirmationData = null;
    NiceModal.remove(DuprModal);
  },
  confirmConnection: (data) => {
    let url, method, params;

    if (gon.tournament && gon.player && gon.player.id) {
      url = "/players/" + gon.player.id + "/dupr";
      method = 'post';
      params = { dupr_xid: data.duprId, rating: data.stats.doubles, singles: data.stats.singles };
    } else {
      url = "/users/" + gon.user.id;
      method = 'put';
      params = { user: { dupr_xid: data.duprId } };
    }

    callWithCatch({
      url, method, params,
      onSuccess: () => {
        DuprConnect.dupr_xid = data.duprId;
        DuprConnect.rating = parseFloat(data.stats.doubles);
        DuprConnect.confirmationData = null;

        if (gon.user) gon.user.dupr_xid = data.duprId;

        NiceModal.remove(DuprModal);
        notification.success({message: "DUPR Connected"});

        if (DuprConnect.callback)
          DuprConnect.callback();
        else {
          location.reload();
        }
      }
    })
  },
  open: (callback) => {
    DuprConnect.callback = callback;
    NiceModal.show(DuprModal);
  }
});

window.addEventListener('message', DuprConnect.handleMessage);